export default __webpack_public_path__ + "static/media/tenant_id_icon.8cc3423f.svg";